import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { DefaultPerPageValue, PerPage } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import userImage from "../../assets/images/icons/ticket.png";
import { Helmet } from "react-helmet";
import { filter } from "lodash/collection";
import { get } from "lodash/object";
import { getIconPath } from "../../helpers/file_helper";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { getAllProject, updateProjectRating } from "../../api/casp/project";
import { Rating } from "@mui/material";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Search from "../../Components/casp/common/Search";
import { ProjectStatuses } from "../../constants/Status";


const ProjectAssesmentList = (props) => {
  const [projectList, setProjectList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [rowCount, setRowCount] = useState(0);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const location = useLocation()

  useEffect(() => {
    const filter = location?.state?.filterData ? JSON.parse(location.state?.filterData) : {
      filterFields: ["status"],
      filterInputs: [ProjectStatuses.ONGOING]
    }
    fetchProjectList({ page: page + 1, perPage: rowsPerPage, ...filter });
  }, [triggerData, location?.state?.filterData]);

  const columns = [
    {
      field: "index",
      headerName: "#",
      width: 85,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div className="MuiDataGrid-cellContent">{params.row?.indexNo}</div>
        </div>
      ),
    },
    {
      field: "uniqueProjectId",
      headerName: props.t("Startup ID"),
      width: 250,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div className="MuiDataGrid-cellContent">
            {params.row?.uniqueProjectId}
          </div>
        </div>
      ),
    },
    {
      field: "projectName",
      headerName: props.t("Startup Name"),
      width: 250,
      filterable: false,
      sortable: false,
    },
    {
      field: "rating",
      headerName: props.t("Startup Ratings"),
      width: 250,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div className="d-flex align-items-center">
          <Rating
            name="simple-controlled"
            value={params.row?.rating}
            onChange={(event, newValue) => {
              handleUpdateProjectRating({ rating: newValue, id: params.row.id })
            }} />
          {params.row?.rating > 0 && <span className="statusBadge badge-outlined text-capitalize align-items-center">{params.row?.rating * 20} %</span>}
        </div>
      ),
    },
  ];

  const fetchProjectList = async (queryParams) => {
    try {
      setIsLoading(true);
      let params = {
        ...queryParams,
        ...(search && { search }),
      }
      const res = (await getAllProject(params)).data.data;
      let level = (params?.page + 1 - 1) * params?.perPage;
      const resultData = res.data.map((res) => {
        return {
          id: res.id,
          indexNo: ++level,
          uniqueProjectId: res.uniqueProjectId,
          projectName: res.name,
          rating: res?.rating,
        };
      });
      setProjectList(resultData);
      setRowCount(res.meta.total);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const handleUpdateProjectRating = async (data) => {
    try {
      const response = await updateProjectRating({ rating: data?.rating }, data?.id);
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        setProjectList([]);
        setPage(0)
        setTriggerData(+new Date());
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Global Search
  const globalSearch = async (params) => {
    setSearch(params.search);
    const filter = location?.state?.filterData ? JSON.parse(location.state?.filterData) : {}
    await fetchProjectList({ ...params, ...filter });
  };

  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
    setTriggerData(+new Date());
  };

  const getRowId = (row) => row.id;

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, "linkTags", []), {
                rel: "icon",
              });

              if (!newFaviconElems.length) {
                return;
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href;

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              );

              if (existingFavicons.length) {
                existingFavicons.forEach((e) => e.parentNode.removeChild(e));
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              );
              const iconToShow = <ManageAccountsIcon />;
              //<i className={'ri-git-pull-request-line'}></i>

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true);
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                    iconToShow
                  )}</svg>`
                )}`;
                const parentElem = newFaviconElem.parentNode;
                parentElem.removeChild(newFaviconElem);
                parentElem.appendChild(newFavElement);
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <title>{props.t("Startup List")}</title>
        </Helmet>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center ongoingProjectsPg">
            <div className="mainPageHeader d-flex justify-content-between">
              <BreadCrumb title={props.t("Startup List")} />
            </div>


            <div className="d-flex justify-content-end ongoingSearchField">
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    ...(props?.status ? {
                      filterFields: ["status"],
                      filterInputs: [props.status]
                    } : {}),
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
                {/* <SearchOutlinedIcon /> */}
              </div>
            </div>
          </div>
          <div className="accordionTable my-4" style={{ width: "100%" }}>
            {projectList.length > 0 && (
              <DataGrid
                key={refreshKey}
                rows={projectList}
                columns={columns}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={rowCount}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
                localeText={{
                  noRowsLabel: props.t("No rows"),
                  MuiTablePagination: {
                    labelRowsPerPage: props.t("Rows per page:"),
                  },
                }}
              />
            )}
            {projectList.length === 0 && isLoading && <Loader />}
            {projectList.length === 0 && !isLoading && (
              <NodataFound text={props.t("No startup assessment List to show")} icon={userImage} />
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(ProjectAssesmentList)
